import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type SelectedSchool = {
  Id: string
  Name: string
  City: string
  State: string
  TimeZone?: string
}
type State = SelectedSchool[]

const slice = createSlice({
  name: 'selectedSchools',
  initialState: [] as State,
  reducers: {
    addSelectedSchool: (state, action: PayloadAction<SelectedSchool>) => {
      state.push(action.payload)
    },
    removeSelectedSchool: (state, action: PayloadAction<number>) => {
      state.splice(action.payload, 1)
    },
    setSelectedSchools: (_, action: PayloadAction<SelectedSchool[]>) => action.payload,
  },
})

export const actions = slice.actions
export default slice.reducer
